export const LOGGED_IN_USER_DETAILS_API = '/api/User/Self';
export const USER_API = '/api/User';
export const GET_USER_ODATA_API = '/api/User/search';
export const GET_TOWER_PC_USERS = '/api/User/GetGenericUsers';

export const ROLE_API = '/api/Role';
export const ROLE_LIST_API = '/api/Role/list';
export const POLICY_API = '/api/Policy';

export const COP_USER_ACCESS = '/api/Role/GetUserRoles';
export const COP_USER_UPDATE_API = '/api/User/AddOrUpdateUserWithGenesisAccess';

export const USER_PREFERENCES = '/api/UserDashboardPreferences';

export const MESSAGES = {
  REQUIRED_NAME: 'User Name is required',
  REQUIRED_SHORT_ID: 'Short Id is required',
  REQUIRED_EMAIL: 'Email is required',
  REQUIRED_APPLICATION_ROLE: 'Atleast one role is required',
  EMAIL_PATTERN: 'Enter a valid email, Including the domain shell.com',
  USER_NAME_PATTERN: 'User Name must be Including alphabets only',
  SHORT_ID_PATTERN: 'Short Id must be alpha numeric only',
  UPDATED_SUCCESSFULLY: 'User updated successfully!',
  CREATED_SUCCESSFULLY: 'User created successfully!',
  UPDATE_FAILED: 'Update user failed!',
  CREATE_FAILED: 'Create user failed!',

  // Role and permissions
  REQUIRED_ROLE_NAME: 'Role name is required',
  VALID_ROLE_NAME:
    'Enter a valid role. it allows only alphanumeric, and it must start with an alphabetical character',
  UPDATED_ROLE_SUCCESSFULLY: 'Role and permissions updated successfully!',
  CREATED_ROLE_SUCCESSFULLY: 'Role and permissions created successfully!',
  UPDATE_ROLE_FAILED: 'Update role and permissions failed!',
  CREATE_ROLE_FAILED: 'Create role and permissions failed!',
};

export const EMAIL_REGEX = /^[_A-Za-z0-9.+-]+(\\.[_A-Za-z0-9-]+)*@shell.com$/;
